"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamLeader = void 0;
const isTeamLeader = (examinerNumber) => !!examinerNumber && examinerNumber.split('.')[1] === '01';
exports.isTeamLeader = isTeamLeader;
